import { Row } from 'antd'
import useLineItemCreate from 'app/components/Core/Checkout/hooks/useLineItemCreate'
import { useProductIndex } from 'app/components/Core/Checkout/hooks/useProduct'
import Container from 'app/components/UI-Elements/Layout/Container'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { useBrowserRouterContext } from 'app/lib/contexts/KBrowserRouter'
import useSetBackHistory from 'app/lib/hooks/useSetBackHistory'
import useTitle from 'app/lib/hooks/useTitle'
import { getQueryString } from 'app/lib/utils/search-params'
import { PageProps } from 'app/pages/typing'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import CheckoutStepper from '../Component/Stepper'
import InitialPage from '../Container/InitialPage'
import Machines from '../Container/Machines'

const Index: React.FC<PageProps> = (props) => {
  useTitle(props)
  const { checkout_id: rental_id } = useParams<{ checkout_id: string }>()
  const { search } = useLocation()
  const { setBackRoute } = useBrowserRouterContext()
  const navigate = useNavigate()
  const { open: openLineItemCreate } = useLineItemCreate()

  const { data, loading } = useProductIndex({ id: rental_id })

  useEffect(() => {
    const categorySegmentId = getQueryString(search, 'category_segment_id')
    if (categorySegmentId) {
      navigate({ search: '' }, { replace: true })
      openLineItemCreate({ categorySegmentId: Number(categorySegmentId) })
    }
  }, [])

  useSetBackHistory(() => {
    setBackRoute(Routes.Checkout.member(rental_id).address)
  })

  return (
    <Container>
      <Row gutter={[{ md: 24, xs: 0 }, 24]}>
        <KCol span={24}>
          <CheckoutStepper activeStep={1} />
        </KCol>
        <KCol loading={loading} span={24}>
          <Choose>
            <When condition={data.length > 0}>
              <Machines />
            </When>
            <Otherwise>
              <InitialPage />
            </Otherwise>
          </Choose>
        </KCol>
      </Row>
    </Container>
  )
}

export default Index
